export default {
    data() {
        return {
            cashoutQueue: []
        };
    },
    methods: {
        capitalizeVisibility(str) {
            return capitalizeFL(str);
        },
        getComment(comment) {
            let result = comment.comment;
            if(comment.replyToIds && comment.replyToIds.length > 0) {
                comment.replyToUsers.forEach(cItem => {
                    result = result.replace(`@${cItem.alias},`, `<a href="#/user_tip_stat/${cItem._id}"><strong>@${cItem.alias}</strong></a>`);
                });
            } 
            return result;
        },
        handleLikeTip(tip_id) {
            let index = this.data.findIndex(item => item._id === tip_id);
            try {
                this.toggleLikeTip({id: this.data[index]._id}).then(({data, status, ...rest}) => {
                    if(status === 'success') {
                        this.data[index].like = data.like;
                        this.data[index].likeTip = !this.data[index].likeTip;
                    }
                });
            } catch(err) {
                displayError(err);
            }
        },
        handleFollowTip(tip_id) {
            let index = this.data.findIndex(item => item._id === tip_id);
            try {
                this.toggleFollowTip({id: this.data[index]._id}).then(({data, status, ...rest}) => {
                    if(status === 'success') {
                        this.data[index].follow = data.follow;
                        this.data[index].followTip = !this.data[index].followTip;
                    }
                });
            } catch(err) {
                displayError(err);
            }
        },
        handleFollowUser(tip_id) {
            let index = this.data.findIndex(item => item._id === tip_id);
            let userId = this.data[index].userId;
            try {
                this.toggleFollowUser({
                    toUserId: userId,
                    fromUserId: parseInt(this.loggedInUser.user_id)
                }).then(({data, status, ...rest}) => {
                    if(status === 'success') {
                        // this.data[index].isFollowed = !this.data[index].isFollowed;
                        this.userIsFollowed = !this.userIsFollowed;
                        if(!this.data[index].isFollowed) {
                            // this.data[index].followUserCount ++;

                            if (this.total_stat)
                                this.total_stat.followers ++;
                            else if (this.stat)
                                this.stat.followers ++;
                        }
                        else {
                            // this.data[index].followUserCount --;

                            if (this.total_stat)
                                this.total_stat.followers --;
                            else if (this.stat)
                                this.stat.followers --;
                        }
                                                
                        for (var i=0; i < this.data.length; i++) {
                            if (this.data[i].userId != userId)
                                continue;
                            this.data[i].isFollowed = !this.data[i].isFollowed;
                            if(this.data[i].isFollowed) {
                                this.data[i].followUserCount ++;
                            }
                            else {
                                this.data[i].followUserCount --;
                                
                            }
                        }

                    }
                });
            } catch(err) {
                displayError(err);
            }
        },
        handleFollowUser_(toUserId, fromUserId) {
            
            try {
                this.toggleFollowUser({
                    toUserId: parseInt(toUserId),
                    fromUserId: parseInt(fromUserId)
                }).then(({data, status, ...rest}) => {
                    if(status === 'success') {
                        this.userIsFollowed = !this.userIsFollowed;
                        console.log('this.userIsFollowed', this.userIsFollowed)
                        if(this.userIsFollowed){
                            if (this.total_stat)
                                this.total_stat.followers ++;
                            else if (this.stat)
                                this.stat.followers ++;
                        }
                        else{
                            if (this.total_stat)
                                this.total_stat.followers --;
                            else if (this.stat)
                                this.stat.followers --;
                        }

                        for (var i=0; i < this.data.length; i++) {
                            if (this.data[i].userId != toUserId)
                                continue;
                            this.data[i].isFollowed = !this.data[i].isFollowed;
                            if(this.data[i].isFollowed) {
                                this.data[i].followUserCount ++;
                            }
                            else {
                                this.data[i].followUserCount --;
                                
                            }
                        }

                    }
                });
            } catch(err) {
                displayError(err);
            }
        },
        handleFollowStrategy(tip_id) {
            let index = this.data.findIndex(item => item._id === tip_id);
            let strategy = this.data[index].strategyData;
            this.toggleFollowStrategy({
                id: strategy._id
            }).then(({data, status}) => {
                this.data[index].strategyData = data;
            });
        },
        handleFollowStrategy_(strategyId) {
            
            this.toggleFollowStrategy({
                id: strategyId
            }).then(({data, status}) => {
                this.strategyIsFollowed = !this.strategyIsFollowed;
                if(this.strategyIsFollowed)
                    this.stat.followers ++;
                else
                    this.stat.followers --;
            });
        },
        handlePostComment(tip_id, comment) {
            let idx = this.data.findIndex(item => item._id === tip_id);
            let tipData = this.data[idx];
            let userId = localStorage.getItem('user_id');
            let params = {
                tipId: tipData._id,
                commentorId: parseInt(userId),
                comment: comment,
                replyToIds: tipData.replyTo.filter(rItem => comment.includes(`@${rItem.alias}`)).map(rItem => rItem._id)
            };
            try {
                this.postComment(params).then(({data, status, ...rest}) => {
                    if(status === 'success') {
                        this.data[idx].replyTo = [];
                    }
                });
            } catch(err) {
                displayError(err);
            }
        },
        handleSelectReply(tip_id, user) {
            let idx = this.data.findIndex(item => item._id === tip_id);
            let tipData = this.data[idx];
            if(!tipData.replyTo.includes(user)) {
                this.data[idx].replyTo.push(user);
            } 
        },
    }
};